import serviceAxios from "../index";


function index_order_list(params) {
	return serviceAxios({
		url: '/api/electicianOrder/list',
		method: 'get',
		params
	})
}

function index_orderdg_list(params) {
	return serviceAxios({
		url: '/api/electicianOrder/dgList',
		method: 'get',
		params
	})
}


function index_order_detail(params) {
	return serviceAxios({
		url: '/api/electicianOrder/getDetil',
		method: 'get',
		params
	})
}

function index_order_statistics(params) {
	return serviceAxios({
		url: '/api/electicianOrder/statistics',
		method: 'get',
		params
	})
}

function index_order_meList(params) {
	return serviceAxios({
		url: '/api/electicianOrder/meList',
		method: 'get',
		params
	})
}

function electrician_userinfo(params) {
	return serviceAxios({
		url: '/api/master/getInfo',
		method: 'get',
		params
	})
}
// 查看电工 详情
function getInfoById(params) {
	return serviceAxios({
		url: '/api/master/getInfoById/' + params,
		method: 'get'
	})
}
function electrician_type() {
	return serviceAxios({
		url: '/api/master/electicianType',
		method: 'get'
	})
}

function electrician_info_update(data) {
	return serviceAxios({
		url: '/api/master/update',
		method: 'post',
		data
	})
}

function electrician_info_password(params) {
	return serviceAxios({
		url: '/api/master/updatePwd',
		method: 'get',
		params
	})
}

function electrician_order_update(data) {
	return serviceAxios({
		url: '/api/electicianOrder/update',
		method: 'post',
		data
	})
}

export function elecPingListApi(params) {
	return serviceAxios({
		url: '/api/electicianOrder/meList',
		method: 'get',
		params
	})
}

export function elecPingUpdateApi(data) {
	return serviceAxios({
		url: '/api/electicianOrder/update',
		method: 'post',
		data
	})
}

export function elecPingDetailApi(params) {
	return serviceAxios({
		url: '/api/electicianOrder/getDetil',
		method: 'get',
		params
	})
}

//取消订单
function deleteOrderApi(params) {
	return serviceAxios({
		url: '/api/electicianOrder/delOrder',
		method: 'get',
		params
	})
}

//接收订单
function acceptOrderApi(data) {
	return serviceAxios({
		url: '/api/electicianOrder/accept',
		method: 'post',
		data
	})
}

//收入统计
export function staFirstApi(params) {
	return serviceAxios({
		url: '/api/electicianOrder/income',
		method: 'get',
		params
	})
}

//我的收入订单统计
export function staSecApi(params) {
	return serviceAxios({
		url: '/api/electicianOrder/orderNum',
		method: 'get',
		params
	})
}

//收入列表
export function staThApi(params) {
	return serviceAxios({
		url: '/api/electicianOrder/incomeList',
		method: 'get',
		params
	})
}

//拒绝订单
export function refuseOrderApi(params) {
	return serviceAxios({
		url: '/api/electicianOrder/refuseOrder',
		method: 'get',
		params
	})
}

//通过状态码查看需求列表
export function addOrder(params) {
	return serviceAxios({
		url: '/api/system/need/addOrder',
		method: 'post',
		data: params
	})
}
// 提取 需求
export function editOrder(params) {
	return serviceAxios({
		url: '/api/system/need/ele/edit',
		method: 'post',
		data: params
	})
}
// 电工 查看 订单列表
export function shareOrderList(params) {
	return serviceAxios({
		url: '/api/system/need/shareOrderList',
		method: 'get',
		params: params
	})
}
//电工 查看 需求详情
export function orderDetail(params) {
	return serviceAxios({
		url: '/api/system/need/ele/'+params,
		method: 'get'
	})
}
//电工 结算单确认
export function eleAcc(params) {
	return serviceAxios({
		url: '/api/system/need/ele/eleAcc',
		method: 'post',
		data: params
	})
}
//电工 首页 未完成需求单
export function getNearRest(params) {
	return serviceAxios({
		url: '/api/system/need/getNearRest',
		method: 'get',
		params: params
	})
}
// 需求单详情
export function orderDetails(params) {
	return serviceAxios({
		url: '/api/system/need/com/'+params,
		method: 'get'
	})
}
// 查看绑定的订单信息
export function selectBindShareOrder(params) {
	return serviceAxios({
		url: '/api/system/need/selectBindShareOrder/'+params.id,
		method: 'get',
		params: params
	})
}
// 结束招工
export function endRecruitment(params) {
	return serviceAxios({
		url: '/api/system/need/sucess',
		method: 'post',
		data: params
	})
}
// 修改或新增 结算单
export function insertShareAccount(params) {
	return serviceAxios({
		url: '/api/system/need/insertShareAccount',
		method: 'post',
		data: params
	})
}
// 确认结算单（完工）
export function addsAccount(params) {
	return serviceAxios({
		url: '/api/system/need/com/addsAccount/'+params,
		method: 'get'
	})
}
// 查询 付款 详情
export function selectCountMeoney(params) {
	return serviceAxios({
		url: '/api/system/need/selectCountMeoney/'+params,
		method: 'get'
	})
}
// 客户 打款
export function sendMoney(params) {
	return serviceAxios({
		url: '/api/system/need/com/sendMoney',
		method: 'post',
		data: params
	})
}
// 电工 确认 收款
export function getMoney(params) {
	return serviceAxios({
		url: '/api/system/need/ele/getMoney',
		method: 'post',
		data: params
	})
}
// 电工 首页 统计信息
export function selectCountNeedOrder() {
	return serviceAxios({
		url: '/api/workshare/selectCountNeedOrder',
		method: 'get'
	})
}
export default {
	index_orderdg_list,
	index_order_list,
	index_order_detail,
	index_order_meList,
	index_order_statistics,
	electrician_userinfo,
	getInfoById,
	electrician_type,
	electrician_info_update,
	electrician_info_password,
	electrician_order_update,
	deleteOrderApi,
	acceptOrderApi,
	refuseOrderApi,
	addOrder,
	editOrder,
	shareOrderList,
	orderDetail,
	eleAcc,
	getNearRest,
	orderDetails,
	selectBindShareOrder,
	endRecruitment,
	insertShareAccount,
	addsAccount,
	selectCountMeoney,
	sendMoney,
	getMoney,
	selectCountNeedOrder
}
